var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"pdfviewerFrame",attrs:{"height":"98%","width":"100%","src":_vm.getFilePath}})}
var staticRenderFns = []

export { render, staticRenderFns }